var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560 560",
    width: 560,
    height: 560,
    role: "img",
    "aria-label": "Patient mobile app",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Patient mobile app") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "apBg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#EAF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EDF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "apHero",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#011936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#257CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "apRing",
    x1: 0,
    y1: 1,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF2FF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "apShadow",
    x: "-30%",
    y: "-20%",
    width: "160%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 14,
    stdDeviation: 20,
    floodColor: "#011936",
    floodOpacity: 0.2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "apChip",
    x: "-45%",
    y: "-45%",
    width: "190%",
    height: "190%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 5,
    stdDeviation: 10,
    floodColor: "#011936",
    floodOpacity: 0.14
  })), /*#__PURE__*/React.createElement("filter", {
    id: "apBlur",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "apClip"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 280,
    r: 280
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "apScreen"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 74,
    width: 208,
    height: 412,
    rx: 26
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#apClip)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 560,
    fill: "url(#apBg)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 150,
    r: 100,
    fill: "#257CFF",
    opacity: 0.36,
    filter: "url(#apBlur)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 430,
    r: 104,
    fill: "#59C3FF",
    opacity: 0.4,
    filter: "url(#apBlur)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 440,
    cy: 130,
    r: 72,
    fill: "#CFE2FF",
    opacity: 0.32,
    filter: "url(#apBlur)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#apShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 64,
    width: 228,
    height: 432,
    rx: 36,
    fill: "#011936"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 74,
    width: 208,
    height: 412,
    rx: 26,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#apScreen)",
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 192,
    y: 94,
    fontSize: 9,
    fontWeight: 600,
    fill: "#011936"
  }, "9:41"), /*#__PURE__*/React.createElement("g", {
    fill: "#011936"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332,
    y: 87,
    width: 3,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337,
    y: 85,
    width: 3,
    height: 7,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 83,
    width: 3,
    height: 9,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 84,
    width: 14,
    height: 8,
    rx: 2.4,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.5,
    y: 85.5,
    width: 9,
    height: 5,
    rx: 1.4
  })), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 100,
    width: 208,
    height: 150,
    fill: "url(#apHero)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 192,
    y: 126,
    fontSize: 10.5,
    fill: "#B9C7DC"
  }, "Good morning"), /*#__PURE__*/React.createElement("text", {
    x: 192,
    y: 144,
    fontSize: 15,
    fontWeight: 700,
    fill: "#fff"
  }, "Your day"), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 132,
    r: 15,
    fill: "#ffffff",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 127,
    r: 5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.6 141c1.4-4.8 4.8-7 8.4-7s7 2.2 8.4 7z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(232,196)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 34,
    fill: "none",
    stroke: "#ffffff",
    strokeOpacity: 0.22,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    r: 34,
    fill: "none",
    stroke: "url(#apRing)",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeDasharray: "164 214",
    transform: "rotate(-90)"
  }), /*#__PURE__*/React.createElement("text", {
    y: -1,
    fontSize: 19,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "77%"), /*#__PURE__*/React.createElement("text", {
    y: 14,
    fontSize: 8.5,
    fill: "#B9C7DC",
    textAnchor: "middle"
  }, "today")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(292,168)"
  }, /*#__PURE__*/React.createElement("text", {
    fontSize: 9,
    fill: "#B9C7DC"
  }, "Streak"), /*#__PURE__*/React.createElement("text", {
    y: 18,
    fontSize: 16,
    fontWeight: 700,
    fill: "#fff"
  }, "18 d"), /*#__PURE__*/React.createElement("text", {
    y: 40,
    fontSize: 9,
    fill: "#B9C7DC"
  }, "Next dose"), /*#__PURE__*/React.createElement("text", {
    y: 58,
    fontSize: 16,
    fontWeight: 700,
    fill: "#fff"
  }, "2:30p")), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 238,
    width: 208,
    height: 248,
    rx: 22,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 192,
    y: 266,
    fontSize: 11.5,
    fontWeight: 700,
    fill: "#011936"
  }, "Today&#8217;s plan"), /*#__PURE__*/React.createElement("text", {
    x: 345,
    y: 266,
    fontSize: 9.5,
    fill: "#7C8AA5",
    textAnchor: "end"
  }, "3 of 4"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 276,
    width: 180,
    height: 40,
    rx: 12,
    fill: "#F4F9F4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 296,
    r: 10,
    fill: "#3CD856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.6 296.2l3 3 5.6-6",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 228,
    y: 292,
    fontSize: 10.5,
    fontWeight: 600,
    fill: "#011936"
  }, "Pelvic floor exercise"), /*#__PURE__*/React.createElement("text", {
    x: 228,
    y: 305,
    fontSize: 9,
    fill: "#7C8AA5"
  }, "10 min &#183; completed")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 322,
    width: 180,
    height: 40,
    rx: 12,
    fill: "#F4F9F4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 342,
    r: 10,
    fill: "#3CD856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.6 342.2l3 3 5.6-6",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 228,
    y: 338,
    fontSize: 10.5,
    fontWeight: 600,
    fill: "#011936"
  }, "Morning medication"), /*#__PURE__*/React.createElement("text", {
    x: 228,
    y: 351,
    fontSize: 9,
    fill: "#7C8AA5"
  }, "8:00 am &#183; taken")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 368,
    width: 180,
    height: 40,
    rx: 12,
    fill: "#F6F8FB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 388,
    r: 10,
    fill: "none",
    stroke: "#CFE2FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 228,
    y: 384,
    fontSize: 10.5,
    fontWeight: 600,
    fill: "#011936"
  }, "Log symptoms"), /*#__PURE__*/React.createElement("text", {
    x: 228,
    y: 397,
    fontSize: 9,
    fill: "#7C8AA5"
  }, "Due this evening")), /*#__PURE__*/React.createElement("text", {
    x: 192,
    y: 430,
    fontSize: 10,
    fontWeight: 600,
    fill: "#011936"
  }, "This week"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 440,
    width: 16,
    height: 24,
    rx: 5,
    fill: "#CFE2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 434,
    width: 16,
    height: 30,
    rx: 5,
    fill: "#CFE2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 446,
    width: 16,
    height: 18,
    rx: 5,
    fill: "#CFE2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 428,
    width: 16,
    height: 36,
    rx: 5,
    fill: "#257CFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 438,
    width: 16,
    height: 26,
    rx: 5,
    fill: "#CFE2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 450,
    width: 16,
    height: 14,
    rx: 5,
    fill: "#CFE2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 442,
    width: 16,
    height: 22,
    rx: 5,
    fill: "#CFE2FF"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 470,
    width: 208,
    height: 16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 478,
    width: 64,
    height: 4,
    rx: 2,
    fill: "#D6DDE8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#apChip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 186,
    width: 118,
    height: 46,
    rx: 14,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 209,
    r: 13,
    fill: "#DCF2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 202.5v7M82 213.5v1",
    stroke: "#257CFF",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 206,
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 10.5,
    fontWeight: 600,
    fill: "#011936"
  }, "Reminder"), /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 219,
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 9,
    fill: "#7C8AA5"
  }, "in 40 min"), /*#__PURE__*/React.createElement("g", {
    filter: "url(#apChip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 316,
    width: 126,
    height: 46,
    rx: 14,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 339,
    r: 13,
    fill: "#EEF7EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.5 339l3.4 3.4 7.6-7.6",
    fill: "none",
    stroke: "#2E9E45",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 410,
    y: 336,
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 10.5,
    fontWeight: 600,
    fill: "#011936"
  }, "Symptoms"), /*#__PURE__*/React.createElement("text", {
    x: 410,
    y: 349,
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 9,
    fill: "#7C8AA5"
  }, "improving"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppPatient);
export default __webpack_public_path__ + "static/media/app-patient.2e103f2e0b6e7e639d674906727c363d.svg";
export { ForwardRef as ReactComponent };